package org.zq.astrock_ai.network

import kotlinx.browser.window

/**
 * Web 部署在 a.aiotzq.com 时走同域相对路径 /api/…。
 * 本地预览（localhost）直连线上后端，否则 /api 会打到前端端口，验证码接口 404。
 */
actual fun apiBaseUrl(): String = resolveWebApiBaseUrl(window.location.hostname)
